import React, { useEffect, useRef, useState } from 'react';
import './Goal.scss';
import { safeHtml } from '../../../../services/helpers';
import { useMediaQuery } from 'react-responsive';
import { baseStrapiURL } from '../../../../services/config';

export default function Goal({ content}) {
    const isMobile = useMediaQuery({ maxWidth: 768 }); // Breakpoint pour MD
    const [backgroundImage, setBackgroundImage] = useState('');
    const goalBkgRef = useRef(null);

    useEffect(() => {
        setBackgroundImage(baseStrapiURL + content.Photo.url)
    }, [])

    useEffect(() => {
        const checkWebPSupport = () => {
            const img = new Image();
            img.onload = () => {
                if (img.height > 0 && img.width > 0) {
                    setBackgroundImage(baseStrapiURL + content.Photo.url);
                }
            };

        };
        checkWebPSupport();
    }, []);

    window.addEventListener('scroll', function() {
        if (goalBkgRef.current && !isMobile) {
        }
    });    

    return (
        <div
            className="workshop-goal-bkg"
            ref={goalBkgRef}
            style={{
                backgroundImage: `url(${backgroundImage})`
            }}
        >
            <div className="workshop-goal" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
        </div>

    )
}
